import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ConfirmationModal = ({ show, onClose, onConfirm, title, body, confirmText = "Yes", closeText = "Close" }) => {
  return (
    <Modal show={show} onHide={onClose} >
      <Modal.Header closeButton>
        <Modal.Title>{title || "Confirm Action"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{body || "Are you sure you want to proceed?"}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} style={{backgroundColor:'#cccccc' , color:'#333333' , border:'none'}}>
          {closeText}
        </Button>
        <Button variant="primary" style={{backgroundColor:'#87BFBB' , color:'#000000' , border:'none'}} onClick={onConfirm}>
          {confirmText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
